import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";
import { StyledSuggestionsIndicator } from "./styles";
import { IndicatorThemeType } from "./types";

type Props = {
    isVisible: boolean;
    isPending: boolean;
    withAnimation: boolean;
    onAnimationStart?: VoidFunction;
};

const SuggestionsIndicator = ({
    children,
    isPending,
    isVisible,
    withAnimation,
    onAnimationStart,
}: PropsWithChildren<Props>) => {
    const [isWithBounceAnimation, setIsWithBounceAnimation] = useState(false);

    useEffect(() => {
        const shouldTriggerAnimation = isPending && isVisible;

        setIsWithBounceAnimation(shouldTriggerAnimation);
    }, [isPending, isVisible]);

    useEffect(() => {
        if (!withAnimation) {
            setIsWithBounceAnimation(false);
        }
    }, [withAnimation]);

    const getStylingThemeType = (): IndicatorThemeType => {
        switch (true) {
            case isPending:
                return IndicatorThemeType.Pending;
            default:
                return IndicatorThemeType.Stale;
        }
    };

    return (
        <StyledSuggestionsIndicator
            themeType={getStylingThemeType()}
            isVisible={isVisible}
            withBounceAnimation={isWithBounceAnimation}
            onAnimationStart={onAnimationStart}
        >
            {children}
        </StyledSuggestionsIndicator>
    );
};

export default SuggestionsIndicator;
